import type { GlobalTourConfig } from '@components/tours/types';
import { createWelcomeTour, WELCOME_TOUR_ID } from './welcome';
import storeModule from '@store';

// Registry of all global tours — uses getter for lazy ERP-aware config evaluation
export const globalTourConfigs = {
  get [WELCOME_TOUR_ID](): GlobalTourConfig {
    const state = storeModule.store.getState();
    const isWithERP = state.membership?.isWithERP ?? false;
    return createWelcomeTour(isWithERP);
  },
} as Record<string, GlobalTourConfig>;

// Re-export individual tours
export { createWelcomeTour };
